import React from "react";

const surveyCompletedItem = "surveyCompleted";

export default function SurveyForm() {
  const [isFormVisible, setFormVisible] = React.useState(false);
  const [isSurveyCompleted, setSurveyCompleted] = React.useState(false);
  const intervalRef = React.useRef();
  const FORM_VISIBILITY_DELAY = (3 * 60 * 1000); // 3 minutes

  const handleFormVisibility = () => {
    const isEULAAccepted = JSON.parse(
      localStorage.getItem("sst_blue_print_eula_accepted")
    );
    const isPlayerEnabled = !JSON.parse(
      localStorage.getItem("InmPlayerCurrent")
    );
    const isSurveyVisible = isEULAAccepted && isPlayerEnabled;

    if (isSurveyVisible) {
      clearInterval(intervalRef.current);
      setFormVisibility();
    }
    return isSurveyVisible;
  };

  React.useEffect(() => {
    if(!handleFormVisibility()) {
      intervalRef.current = setInterval(() => {
        handleFormVisibility();
      }, 3000);
    }
  }, []);

  React.useEffect(() => {
    const surveyCompletedValue =
      JSON.parse(localStorage.getItem(surveyCompletedItem)) || false;
    localStorage.setItem(surveyCompletedItem, surveyCompletedValue);
    setSurveyCompleted(surveyCompletedValue);
  });

  const setFormVisibility = () => {
    setTimeout(() => {
         setFormVisible(true);
    }, FORM_VISIBILITY_DELAY);
  };

  const handleClose = () => {
    setFormVisible(false);
    localStorage.setItem(surveyCompletedItem, true);
    setSurveyCompleted(true);
  };

  return (
    <>
      {isFormVisible && !isSurveyCompleted ? (
        <div className="surveyForm">
          <div className="close">
            <span onClick={handleClose}>Close</span>
          </div>
          <div className="iframeWrapper">
            <iframe
              className="iframe"
              src="https://www.surveymonkey.com/r/YQTW6GQ"
            ></iframe>
          </div>
        </div>
      ) : null}
    </>
  );
}
